export namespace Preference {
    export const KEY = "preference";

    export enum Lab {
        DevMode = "Development Mode",
        PageFeedback = "PageFeedback",
        SharedPageLibraryAdmin = "Shared Page Library Admin",
        DefaultSearchSettings = "default-search-settings",
        WmlcBadgeColorPhoneTool = "wmlc-badge-color-phonetool",
    }
    export class Value {
        userId: string;
        instanceId: string;
        labs: Set<Lab>;
    }
}
